module.exports = __webpack_public_path__ + "img/lan.b8dc9e3e.svg";